import classNames from "classnames";
import BootTextField from "components/common/custom/forms/BootTextField";
import TextInput from "components/common/custom/forms/BootTextField/TextField";
import React, { useState } from "react";
import { Button, Form, Spinner } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { ResetPassword } from "../config/AuthApi";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import paths from "routes/paths";

const ResetPasswordForm = () => {
  const dispatch = useDispatch();
  const { forgotData } = useSelector((state) => state.auth);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const {
    control,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm({
    defaultValues: {
      password: "",
      confirm_password: "",
    },
  });

  const handleResetPassword = async (data) => {
    setLoading(true);
    const body = {
      email: forgotData?.email,
      password: data.password,
      slink: forgotData?.finalURL,
    };

    const response = await dispatch(ResetPassword(body)).unwrap();

    if (response?.success) {
      navigate(paths.login, { replace: true });
      setLoading(false);
      toast.success(response?.message_en);
    } else {
      setLoading(false);
    }
  };

  return (
    <Form
      className={classNames("mt-3")}
      onSubmit={handleSubmit(handleResetPassword)}
    >
      <Form.Group>
        <TextInput
          name="password"
          control={control}
          label="New Password"
          type="password"
          isRequired
          errors={errors}
          rules={{
            required: "Password is required",
            minLength: {
              value: 8,
              message: "Password must be at least 8 characters long",
            },
          }}
        />
        {errors.password && (
          <Form.Control.Feedback type="invalid">
            {errors.password.message}
          </Form.Control.Feedback>
        )}
      </Form.Group>

      <Form.Group className="mt-3">
        <TextInput
          name="confirm_password"
          control={control}
          label="Confirm Password"
          type="password"
          isRequired
          errors={errors}
          rules={{
            required: "Confirm Password is required",
            validate: (value) =>
              value === watch("password") || "Passwords do not match",
          }}
        />
        {errors.confirm_password && (
          <Form.Control.Feedback type="invalid">
            {errors.confirm_password.message}
          </Form.Control.Feedback>
        )}
      </Form.Group>

      <Button type="submit" className="w-100 mt-4" disabled={loading}>
        {loading ? (
          <Spinner size={"sm"} animation="border" />
        ) : (
          "Reset Password"
        )}
      </Button>
    </Form>
  );
};

export default ResetPasswordForm;
